import {createAction} from "redux-act";

export const fetchLiveScores = createAction();
export const unsubscribeFromLiveScores = createAction();
